import React, {useState} from 'react';
import classNames from 'classnames';

import DashboardRoutes from '../routes/DashboardRoutes';
import Sidebar from '../layout/Sidebar';
import Navbar from '../layout/Navbar';

const AppLayout = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(true);

  return (
    <div className="flex">
      <Sidebar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <div
        className={classNames(
          'w-full',
          isMenuOpen ? 'max-w-[calc(100vw-265px)]' : 'max-w-[calc(100vw-80px)]',
        )}
      >
        <Navbar />
        <div className="bg-background min-h-[calc(100vh-88px)]">
          <DashboardRoutes />
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
